/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type QuizCommentaryBlockDto = {
  type: QuizCommentaryBlockDto.type;
  /**
   * 본문 (type=text)
   */
  text?: string;
  /**
   * 이미지 URL (type=image)
   */
  url?: string;
  /**
   * 이미지 캡션 (type=image, 선택)
   */
  caption?: string;
};
export namespace QuizCommentaryBlockDto {
  export enum type {
    TEXT = "text",
    IMAGE = "image",
  }
}
